import React from 'react';
import { Card, Col, Row } from 'react-bootstrap';

const CampaignAdsLoading = () => {
    return (
        <div className="tw-w-full">
            {[...Array(2)].map((_, index) => (
                <div key={index}>
                    <Row className="tw-w-full tw-flex tw-flex-col">
                        <div className="tw-w-full tw-flex tw-items-center tw-gap-x-2 mt-3 tw-mb-0">
                            <span className="tw-flex tw-items-center tw-justify-center tw-w-8 tw-h-8 tw-rounded-full tw-font-bold tw-bg-gray-200 tw-p-3"></span>
                            <div className="tw-w-full tw-flex tw-items-center tw-border tw-border-gray-200 tw-rounded-lg tw-p-4 tw-bg-gray-200"></div>
                        </div>
                        <div className="tw-w-full tw-flex tw-items-center tw-gap-x-2 mt-3 tw-mb-6">
                            <span className="tw-flex tw-items-center tw-justify-center tw-w-8 tw-h-8 tw-rounded-full tw-font-bold tw-bg-white tw-text-white tw-text-base tw-p-3">
                                {1}
                            </span>
                            <Row className="tw-flex flex-wrap tw-m-0 tw-p-0">
                                {[...Array(3)].map((_, i) => (
                                    <Col
                                        xs={12}
                                        sm={6}
                                        lg={4}
                                        key={i}
                                        className="mb-3 tw-pl-0 tw-max-w-[400px] tw-cursor-pointer"
                                    >
                                        <Card className="project-content box-shadow p-2 m-0 position-relative">
                                            <div className="tw-w-[289px] tw-h-[300px] tw-bg-gray-200"></div>
                                        </Card>
                                    </Col>
                                ))}
                            </Row>
                        </div>
                    </Row>
                </div>
            ))}
        </div>
    );
};

export default CampaignAdsLoading;
